import { Suspense, useEffect } from 'react';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CreateStartCodeUserError, useAuthenticateByStartCode } from './api';
import { logOut } from '../../actions/authActions';
import { ErrorBoundary, ErrorBoundaryFallbackProps } from '../../common/ErrorBoundary';
import { ErrorMessage } from '../login/EndUserLogin';
import { Spinner } from '../../common/Spinner';
import { I18N } from '../../internationalization/AppText';
import { TextKeys } from '@visikon/core-models/i18n/translations';
import styled from 'styled-components';
import { Button } from '@visikon/spine';
import { logger } from '@visikon/utils/src/logger';

export const START_CODE_ROUTE = '/start';
export const START_CODE_PATH = `${START_CODE_ROUTE}/:startCode`;

export function StartCodeRouter(props: RouteComponentProps<{ startCode: string }>) {
  const { startCode } = props.match.params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logOut());
  }, []);

  return (
    <CenteredContent>
      <ErrorBoundary fallback={<StartCodeErrorFallback />}>
        <Suspense fallback={<Spinner />}>
          <DirectAccessForwarder startCode={startCode} />
        </Suspense>
      </ErrorBoundary>
    </CenteredContent>
  );
}

function StartCodeErrorFallback({ error }: ErrorBoundaryFallbackProps) {
  const history = useHistory();
  let errorMessage: TextKeys = 'merge_error_unknown_error';

  if (error instanceof CreateStartCodeUserError) {
    errorMessage = error.i18n_error;
  }

  logger.error(`StartCode ErrorBoundary: Failed to activate start code`, error);

  return (
    <>
      {ErrorMessage(errorMessage)}
      <Button onClick={() => history.push('/')}>
        <I18N text="go_back" />
      </Button>
    </>
  );
}

function DirectAccessForwarder({ startCode }: { startCode: string }) {
  const { mutate: authenticateStartCode } = useAuthenticateByStartCode();

  useEffect(() => {
    authenticateStartCode(startCode);
  }, [startCode]);

  return <Spinner />;
}

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100%;
`;
